export interface ShelfSeed {
  id: string
  title: string
  subtitle: string
  term: string
}

export const shelfSeeds: ShelfSeed[] = [
  { id: 'neo-soul', title: 'Velvet Frequencies', subtitle: 'Neo-soul slow burners', term: 'neo soul' },
  { id: 'lofi', title: 'Static & Streetlights', subtitle: 'Lo-fi for the small hours', term: 'lofi' },
  { id: 'daft-punk', title: 'The Robots Are Dancing', subtitle: 'Daft Punk and the French touch', term: 'daft punk' },
  { id: 'jazz-piano', title: 'Last Call Piano', subtitle: 'Jazz piano, one lamp on', term: 'jazz piano' },
  { id: 'synthwave', title: 'Neon Rearview', subtitle: 'Synthwave for the drive home', term: 'synthwave' },
]

export const searchSuggestions: string[] = [
  'neo soul',
  'lofi',
  'daft punk',
  'jazz piano',
  'synthwave',
  'bossa nova',
  'ambient',
  'dub techno',
]

export interface PlaylistSeed {
  name: string
  note: string
  term: string
}

/** Stocked into the library on a first visit, then fully editable. */
export const defaultPlaylistSeeds: PlaylistSeed[] = [
  { name: 'After Hours Drive', note: 'synthwave for empty streets', term: 'synthwave' },
  { name: 'Velvet Sunday', note: 'neo-soul, coffee, no plans', term: 'neo soul' },
  { name: 'Piano at 2AM', note: 'one lamp, one player', term: 'jazz piano' },
]

/** Fallback search terms Night Drift uses when a track has no useful genre. */
export const driftTerms: string[] = ['neo soul', 'late night jazz', 'ambient', 'downtempo', 'soul ballad']
